import { Component } from '@angular/core';
import { Observable, catchError, firstValueFrom, map, of, tap } from 'rxjs';
import { DialogCreaImpegnoComponent } from 'src/app/page/configurazioni/cfg-impegni/dialog/dialog-crea-impegno/dialog-crea-impegno.component';
import { SelezioneElementiQuestionarioComponent } from '../../selezione-elementi-questionario.component';

@Component({
  selector: 'app-selezione-impegni-sintesi',
  templateUrl: '../../selezione-elementi-questionario.component.html',
  styleUrls: ['../../selezione-elementi-questionario.component.scss'],
  standalone: false,
})
export class SelezioneImpegniSintesiComponent extends SelezioneElementiQuestionarioComponent {
  public sonoInCtr: boolean = false;

  override editElementoListaChk(idAmbito: string, idTematica: string, impegno?: any): void {
    impegno = super.addSettoreElemento(impegno);

    const dialogCreaImpegno = this.dialog.open(DialogCreaImpegnoComponent, {
      data: {
        impegno: impegno,
        idContest: this.idContest,
        idAmbito: idAmbito,
        idTematica: idTematica,
        contesto: 'sintesi',
      },
      panelClass: 'dialog-container',
      disableClose: false,
      width: '75%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaImpegno.afterClosed().subscribe((result) => {
      if (result) {
        this.spinnerOver.show();

        if (this.sonoInCtr) {
          impegno.selected = true;
          this.sonoInCtr = false;
        }
        this.salvataggio(idAmbito, idTematica, impegno?.id);
      } else {
        if (this.sonoInCtr) {
          this.spinnerOver.show();
          this.sonoInCtr = false;
          impegno.selected = false;

          this.salvataggio(idAmbito, idTematica, impegno?.id);
        }
      }
    });
  }

  async salvataggio(idAmbito: string, idTematica: string, idImpegno: string) {
    try {
      // Salvo i dati modificati
      await firstValueFrom(this.salva(true));

      // Get dei dati aggiornati
      await firstValueFrom(this._getImpegniSintesi());

      // Scroll all'elemento modificato
      setTimeout(() => {
        this.scrollToElement(idAmbito, idTematica, idImpegno);
      }, 0);
    } catch (error) {
      console.error(error);
    }
  }

  override addElementoListaChk(idAmbito: string, idTematica: string): void {
    // posso passare la stessa funzione poichè la gestione è identica, Cambia solameanete il passaggio del impegno
    // a vuoto nella creazione.
    this.editElementoListaChk(idAmbito, idTematica);
  }

  override salvaFigAz(
    idAmbito: string,
    idTematica: string,
    idImpegno: string,
    idFigAziendale: string,
  ): void {
    this.spinnerOver.show();
    this.sintesiService
      .putAssegnaFiguraImpegnoSintesi(
        this.idContest,
        idAmbito,
        idTematica,
        idImpegno,
        idFigAziendale,
      )
      .subscribe({
        next: () => {
          this.salvataggio(idAmbito, idTematica, idImpegno);
        },
        error: (err) => {
          console.error(err);
          this.spinnerOver.hide();
        },
      });
  }

  private _getImpegniSintesi(): Observable<any> {
    this.spinnerOver.show();

    return this.sintesiService.getImpegniSintesi(this.idContest).pipe(
      tap((esito) => {
        this.objQuestionario = esito;
      }),
      catchError((err) => {
        console.error(err);
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Errore nel recupero degli impegni',
          bottoni: [{ nome_btn: 'Ok' }],
        });
        return of(null);
      }),
      tap({
        finalize: () => this.spinnerOver.hide(),
      }),
    );
  }

  salva(noCtr?: boolean) {
    let impegniSelezionati = this.oggettoElementiSelezionati();

    if (!noCtr) {
      //Controllo se è stato selezionato almeno un impatto per tematica
      if (this.ctrElemChecked(impegniSelezionati, 'impegno')) {
        return of(false);
      }
    }

    return this._salvaSurveyMaterialita(impegniSelezionati);
  }

  private _salvaSurveyMaterialita(impegniSelezionati: any): Observable<boolean> {
    if (this.idContest) {
      return this.sintesiService
        .putImpegniSintesiSelezionati(this.idContest, impegniSelezionati)
        .pipe(
          map((result: any) => {
            this.utilityService.openSnackBar('Aggiornamento effettuato', '', {
              duration: 2000,
              panelClass: ['success-snackbar'],
            });

            this.salvato.emit();

            return true;
          }),
          catchError((err: any) => {
            console.error('Errore :', err);

            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err?.error?.message || 'Errore salvataggio (sconosciuto)',
              bottoni: [{ nome_btn: 'Ok' }],
            });

            return of(false);
          }),
        );
    } else {
      return of(false);
    }
  }
}
